import DOMPurify from 'dompurify';
import { useState, useEffect } from 'react';
import { getButtonCLassNames } from './getButtonCLassNames';

DOMPurify.addHook('beforeSanitizeAttributes', (node) => {
	if (node.nodeName && node.nodeName === 'H1') {
		node.setAttribute('class', 'text-4xl');
	}
	if (node.nodeName && node.nodeName === 'H2') {
		node.setAttribute('class', 'text-3xl');
	}
	if (node.nodeName && node.nodeName === 'H3') {
		node.setAttribute('class', 'text-2xl');
	}
	if (node.nodeName && node.nodeName === 'H4') {
		node.setAttribute('class', 'text-xl');
	}
	if (node.nodeName && node.nodeName === 'H5') {
		node.setAttribute('class', 'text-lg');
	}
	if (node.nodeName && node.nodeName === 'P') {
		node.setAttribute('class', 'text-base');
	}
	if (node.nodeName && node.nodeName === 'P' && node.innerHTML === '&nbsp;') {
		node.setAttribute('class', 'text-special');
	}
	if (node.nodeName && node.nodeName === 'IMG') {
		node.setAttribute('class', 'm-auto');
	}
	if (node.nodeName && node.nodeName === 'A') {
		node.setAttribute('class', 'underline inline');
	}
	if (node.nodeName && node.nodeName === 'BUTTON') {
		node.setAttribute(
			'class',
			`rounded-full font-bold px-6 py-3 ${getButtonCLassNames(node.getAttribute('data-variant'))} active:bg-primary-violet active:border-primary-violet  active:text-white`,
		);

		node.removeAttribute('data-variant');
	}
	if (node.nodeName && node.nodeName === 'UL') {
		node.setAttribute('class', 'list-disc pl-5 py-4');
	}
	if (node.nodeName && node.nodeName === 'OL') {
		node.setAttribute('class', 'list-decimal pl-5 py-4');
	}
	if (node.nodeName && node.nodeName === 'LI') {
		node.setAttribute('class', 'text-base m-0');
	}
});

export const useDOMPurify = (content: string) => {
	const [sanitizedContent, setSanitizedContent] = useState<string>('');

	useEffect(() => {
		const clean = DOMPurify.sanitize(content, {
			ADD_TAGS: ['img'],
			ADD_ATTR: ['src', 'onclick', 'target'],
		});
		setSanitizedContent(clean);
	}, [content]);

	return sanitizedContent;
};
